import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: translations.en,
});

const STORAGE_KEY = "xavier-lang";
const SUPPORTED = ["en", "pt", "es"];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    let stored = null;
    try { stored = localStorage.getItem(STORAGE_KEY); } catch (_) { /* Use browser language when storage is unavailable. */ }
    if (stored && SUPPORTED.includes(stored)) {
      setLangState(stored);
      return;
    }
    if (typeof navigator !== "undefined") {
      const browser = (navigator.language || "en").slice(0, 2).toLowerCase();
      if (SUPPORTED.includes(browser)) {
        setLangState(browser);
      }
    }
  }, []);

  const setLang = (next) => {
    if (!SUPPORTED.includes(next)) return;
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (err) {
      if (process.env.NODE_ENV === "development") {
        console.warn("[Language] failed to persist language preference:", err);
      }
    }
  };

  const t = translations[lang] || translations.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
